<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'xl'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <CRow>
        <CCol sm="12" md="6" lg="6">
          <label>Tipo de Servicio</label>
          <v-select v-model="selected_service_type" :reduce="(type) => type.id" :options="all_service_types"
            label="label" placeholder="Seleccione un tipo" />
        </CCol>
        <CCol sm="12" md="6" lg="6">
          <label>Servicios</label>
          <v-select v-model="data_services" :reduce="(name) => name.id" :options="filtered_services"
            placeholder="Seleccione varias opciones..." label="label" :close-on-select="false" multiple />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" md="12" lg="12" class="mt-3">
          <div class="table-responsive">
            <table id="dataTableLists" class="table table-sm table-hover table-bordered dt-responsive nowrap"
              style="width: 100%">
              <thead>
                <tr>
                  <th width="60">N°</th>
                  <th>Servicio</th>
                  <th>Cantidad</th>
                  <th>Subtotal</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in servicios.table_services" :key="service.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ service.label }} - S/{{ service.price }}</td>
                  <td>
                    <input type="number" class="form-control form-control-sm" v-model.number="service.quantity" min="1"
                      style="width: 80px;" />
                  </td>
                  <td>S/ {{ service.quantity * service.price }} </td>
                  <td>
                    <button class="btn btn-danger btn-sm" @click="removeServiceFromTable(service.id)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" md="12" lg="12">
          <div class="mt-3">
            <strong>Total Precio:</strong> S/ {{ totalPrice }}
          </div>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
      <CButton class="btn-info" :style="{ color: 'white' }" @click="saveServices">
        <i class="fa fa-save"></i>&nbsp;Guardar
      </CButton>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../../shared/inputs/cSelect.vue"

export default {
  name: "c-addcourtesy-modal",
  components: {
    CModal,
    cSelectForm,
  },
  data() {
    return {
      swal: null,
      all_services: [],
      all_service_types: [],
      selected_service_type: null,
      data_services: [],
      servicios: {
        table_services: [],
        total_time: "",
        total_price: 0,
      },
    }
  },
  props: {
    title: String,
    boo_modal: Boolean,
    services: Array,
    service_types: Array,
  },
  mounted() {
    this.$parent.$on("clearServicesData", this.clearServices);
  },
  computed: {
    totalPrice() {
      // Calcula el total de precios (subtotal de todos los servicios)
      const total = this.servicios.table_services.reduce((sum, service) => {
        return sum + service.quantity * service.price;
      }, 0);

      this.servicios.total_price = total;

      return total.toFixed(2); // Formato con dos decimales
    },
    filtered_services() {

      if (!this.selected_service_type) {
        return [];
      }

      return this.all_services.filter(
        service =>
          service.service_type_id === this.selected_service_type
      );
    },
  },
  watch: {
    service_types: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.all_service_types = val;
        }
      }
    },
    services: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.all_services = val;
        }
      }
    },
    selected_service_type() {
      // Solo limpiar el selector de servicios, pero NO borrar la tabla
      this.data_services = [];
    },
    data_services(newServices) {
      // Agregar a la tabla solo los servicios nuevos que aún no estén en ella
      newServices.forEach((serviceId) => {
        const alreadyInTable = this.servicios.table_services.find(
          (service) => service.id === serviceId
        );
        if (!alreadyInTable) {
          const newService = this.all_services.find(
            (service) => service.id === serviceId
          );
          if (newService) {
            this.servicios.table_services.push({
              id: newService.id,
              label: newService.label,
              price: parseFloat(newService.price),
              quantity: 1,
              time: newService.time,
            });
          }
        }
      });
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModalServices");
    },

    removeServiceFromTable(serviceId) {
      this.servicios.table_services = this.servicios.table_services.filter(
        (service) => service.id !== serviceId
      );
      this.data_services = this.data_services.filter((id) => id !== serviceId);
    },
    saveServices() {
      // console.log(this.servicios);
      this.$emit("submitServicesData", { servicios: this.servicios });
      this.mtdClose();
    },
    clearServices() {
      this.servicios = {
        table_services: [],
        total_time: "",
        total_price: 0,
      };
      this.all_services = [],
        this.all_service_types = [],
        this.data_services = [];
    },
  }
}
</script>
<style scoped></style>